import React, { useCallback, useEffect, useRef } from 'react';
import { usePlayerUIContext, showUI, hideUI } from '@24i/player-ui';
import { Hideable, PointerEventsHandler } from './styled';
export const HideableContainer = ({ children, className, showTime, displayed, onShow, onHide, onDisplayedChange, style, }) => {
    const { state: { uiDisplayed }, dispatch, } = usePlayerUIContext();
    const displayTimer = useRef();
    const shouldViewBeDisplayed = displayed !== null && displayed !== void 0 ? displayed : uiDisplayed;
    const canDisplay = displayed !== false;
    const hide = useCallback(() => {
        dispatch(hideUI());
        onHide();
        if (displayTimer.current)
            clearTimeout(displayTimer.current);
    }, [displayTimer.current, onHide]);
    const show = useCallback(() => {
        if (!shouldViewBeDisplayed)
            dispatch(showUI());
        onShow();
        if (displayTimer.current)
            clearTimeout(displayTimer.current);
        displayTimer.current = setTimeout(hide, showTime);
    }, [displayTimer.current, shouldViewBeDisplayed, onShow, hide, showTime]);
    const onMouseDown = () => {
        if (displayTimer.current)
            clearTimeout(displayTimer.current);
    };
    useEffect(() => {
        displayTimer.current = setTimeout(hide, showTime);
        return () => {
            clearTimeout(displayTimer.current);
        };
    }, []);
    useEffect(() => {
        if (onDisplayedChange) {
            onDisplayedChange(shouldViewBeDisplayed);
        }
    }, [shouldViewBeDisplayed]);
    return (React.createElement(Hideable, { "data-test": "HideableContainer", className: `HideableContainer ${className}`, onMouseMove: show, onTouchStart: show, onTouchEnd: onMouseDown, onMouseUp: show, displayed: shouldViewBeDisplayed, style, onMouseDown },
        React.createElement(PointerEventsHandler, { canParentDisplay: canDisplay, parentDisplayed: shouldViewBeDisplayed }),
        children));
};
HideableContainer.displayName = 'HideableContainer';
HideableContainer.defaultProps = {
    showTime: 5000,
    className: '',
    onShow: () => { },
    onHide: () => { },
    style: null,
};
//# sourceMappingURL=index.js.map